import { FC } from "react"
import './checkoutOrder.css'
import { BsChevronLeft } from "react-icons/bs";
import { useNavigate, useParams } from "react-router-dom";
import { useOrder } from "../../hooks/useOrder";


type Props = {
  position: number
  name: string
}



const CheckoutOrder: FC<Props> = ({ position, name }) => {
  const navigate = useNavigate();
  const { pluginspace_id } = useParams();
  const { synchronizeContextToStorage } = useOrder();
  async function navigateToPage() {
    await synchronizeContextToStorage()
    switch (position) {
      case 1:
        navigate(`/${pluginspace_id}/new-cart`);
        return
      case 2:
        navigate(`/${pluginspace_id}/new-customer`);
        return
      case 3:
        navigate(`/${pluginspace_id}/new-order`);
        return
      case 4:
        navigate(`/${pluginspace_id}/new-choose-payment`);
        return
    }
  }

  return (
    <div className="checkoutOrder">

      {position !== 5 && <BsChevronLeft size={24} onClick={() => navigateToPage()} />
      }
      <div className="header_ball">
        {Array(position).fill(null).map((p, i) =>
          <div className={`${position === i + 1 ? 'ball' : 'ball_behind'}`}>
            <span> {i + 1}</span>
          </div>

        )
        }

      </div>

      <span className="title"> {name}</span>

    </div>
  )
}

export { CheckoutOrder }